import Data from "../Data";
import StyleItem from "../StyleItem";
import "../Taketour.css";
import heroTickets from "../../../../assets/images/hero-tickets.png";

const Tickets = ({}) => {
  const { ticketData } = Data();
  return (
    <div>
      {ticketData.map((item, index) => (
        <StyleItem key={index} data={item} />
      ))}
      <div className="taketour-image-section">
        <img src={heroTickets} alt="" />
      </div>
    </div>
  );
};

export default Tickets;
